import { render, staticRenderFns } from "./AwsStart.vue?vue&type=template&id=d6454ea0"
import script from "./AwsStart.vue?vue&type=script&lang=js"
export * from "./AwsStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports